import type { SVGProps } from "react";
export function DarkMode(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-slot="icon"
      {...props}
    >
      <clipPath id="a">
        <path d="m2.3999 2.40002h11.2v11.2h-11.2z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path
          d="m7.7598 7.98127c.00019-1.0215.32614-2.01632.93047-2.83987.60434-.82356 1.45553-1.43293 2.42993-1.73954-.7189-.2258-1.48079-.27918-2.22414-.15583-.74334.12335-1.4472.41997-2.05462.86586s-1.10133 1.02852-1.44177 1.70073c-.34044.67222-.51783 1.41515-.51783 2.16865 0 .75351.17739 1.49644.51783 2.16863.34044.6722.83435 1.2549 1.44177 1.7008.60742.4458 1.31128.7425 2.05462.8658.74335.1234 1.50524.07 2.22414-.1558-.9744-.3066-1.82559-.916-2.42993-1.7395-.60433-.8236-.93028-1.81843-.93047-2.83993z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        />
      </g>
    </svg>
  );
}
